import CancelIcon from '@mui/icons-material/Cancel';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, CircularProgress, Divider, FormControl, IconButton, InputAdornment, InputLabel, List, ListItemButton, ListItemIcon, ListItemText, OutlinedInput } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAdminConfigs } from '../../../hooks/useAdminConfigs';

export const ConfigList = () => {
    const [filter, setFilter] = useState<string>('');

    const { data: configs = [], isFetched } = useAdminConfigs();
    const navigate = useNavigate();

    const getFilteredConfigs = () => {
        if (filter.length > 0) {
            const filterRegex = new RegExp(filter, 'gi');

            return configs.filter(({ name }) => {
                return name.match(filterRegex);
            });
        }
        return configs;
    };

    const handleSelectedConfig = (id: string) => {
        navigate(`/admin/configs/${id}`);
    };

    return (
        <Box sx={{ height: '100%', overflow: 'hidden' }}>
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ p: 3, maxWidth: (theme) => theme.breakpoints.values.sm }}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="filter-configs">Filter Configs</InputLabel>
                        <OutlinedInput
                            id="filter-configs"
                            fullWidth
                            label="Filter Configs"
                            value={filter}
                            onChange={(event) => setFilter(event.target.value)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton aria-label={'clear the filter'} edge="end" onClick={() => setFilter('')}>
                                        <CancelIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                </Box>
                <Divider />
                <Box sx={{ height: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {!isFetched && <CircularProgress />}
                    {isFetched && (
                        <List sx={{ width: '100%', height: '100%', overflowY: 'scroll', p: 0 }}>
                            {getFilteredConfigs().map((config) => {
                                const { _id, name } = config;

                                return (
                                    <ListItemButton key={_id.toString()} divider={true} onClick={() => handleSelectedConfig(_id.toString())}>
                                        <ListItemText primary={name} />
                                        <ListItemIcon>
                                            <NavigateNextIcon />
                                        </ListItemIcon>
                                    </ListItemButton>
                                );
                            })}
                        </List>
                    )}
                </Box>
            </Box>
        </Box>
    );
};
